export default "__VITE_ASSET__DGuoF7hZ__"